import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

export const Page = styled('div')({
  position: 'relative',
  '& .Title + .Heading, & .Title + .Paragraph, & .Paragraph + .Heading': {
    marginTop: '50rem',
  },
  '& .Heading + .Subheading, & .Heading + .Paragraph, & .Subheading + .Paragraph, & .Paragraph + .Subheading': {
    marginTop: '30rem',
  },
  '& .Paragraph + .Paragraph': {
    marginTop: '20rem',
  },
  '@media (max-width: 768px)': {
    '& .Title + .Heading, & .Title + .Paragraph, & .Paragraph + .Heading': {
      marginTop: '40rem',
    },
    '& .Heading + .Subheading, & .Heading + .Paragraph, & .Subheading + .Paragraph, & .Paragraph + .Subheading': {
      marginTop: '25rem',
    },
    '& .Paragraph + .Paragraph': {
      marginTop: '20rem',
    },
  },
});

export const Footer = styled('footer')({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  padding: '20rem',
  boxSizing: 'border-box',
});

export const Navigation = styled('nav')({});

export const Link = styled(RouterLink)(({ theme }) => ({
  fontSize: '13rem',
  color: theme.colors.tertiary_element,
  padding: '10rem',
  '& + &': {
    marginLeft: '30rem',
  },
  // '@media (max-width: 1200px)': {
  //   fontSize: '12rem',
  //   '& + &': {
  //     marginLeft: '20rem',
  //   },
  // },
  // '@media (max-width: 768px)': {
  //   fontSize: '11rem',
  //   '& + &': {
  //     marginLeft: '10rem',
  //   },
  // },
}));
